export type Coordinate = {
    latitude: string;
    longitude: string;
};

export enum VenueType {
    Venue = 'venue',
    Google = 'google',
}
export interface VenueValues extends Coordinate {
    address: Address;
    id: string;
    name: string;
    type: VenueType;
}

export interface Address extends Coordinate {
    address1: string;
    address2: string;
    city: string;
    region: string;
    postalCode: string;
    country: string;
    localizedAddress: string;
}

export type AddressKey = keyof Address;

type BasePlace = {
    value: string;
    content: string;
};

type VenueResult = BasePlace & {
    type: VenueType.Venue;
    data: VenueValues;
};

type GooglePlaceResult = BasePlace & {
    type: VenueType.Google;
    data: google.maps.places.AutocompletePrediction;
};

export type Place = GooglePlaceResult | VenueResult;
